import { render, staticRenderFns } from "./ReviewJds.vue?vue&type=template&id=34bbe9d5&scoped=true&"
import script from "./ReviewJds.vue?vue&type=script&lang=js&"
export * from "./ReviewJds.vue?vue&type=script&lang=js&"
import style0 from "./ReviewJds.vue?vue&type=style&index=0&id=34bbe9d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbe9d5",
  null
  
)

export default component.exports